import { tsValidateArray, tsValidateOptionalId, tsValidateString, tsValidateUniqueId } from '@nu-art/ts-common';
import { accountGroupName } from './consts.js';
export const Validator_Modifiable = {
    label: tsValidateString(100, false),
    accountId: tsValidateUniqueId,
    deviceId: tsValidateUniqueId,
    linkedSessionId: tsValidateOptionalId,
    validSessionJwtMd5s: tsValidateArray(tsValidateUniqueId), //array of MD5s of previous sessions.
    sessionIdJwt: tsValidateString(),
};
export const Validator_Generated = {};
export const DBDef_Session = {
    modifiablePropsValidator: Validator_Modifiable,
    generatedPropsValidator: Validator_Generated,
    dbKey: 'user-account--sessions',
    entityName: 'Session',
    versions: ['1.0.0'],
    frontend: {
        group: accountGroupName,
        name: 'session',
    },
    backend: {
        name: 'user-account--sessions'
    }
};
//# sourceMappingURL=db-def.js.map